import { createReducer, on } from '@ngrx/store';
import {
  DELIMITER_SETTING_FIND_SUCCESS,
  DELIMITER_SETTING_FAILURE,
  DELIMITER_SETTING_UPDATE_FORM,
  DELIMITER_SETTING_RESET_ERROR,
  DELIMITER_SETTING_RESET,
  DELIMITER_SETTING_RESET_FORM,
  DELIMITER_SETTING_FIND_ALL_SUCCESS,
  DELIMITER_SETTING_EDIT_MODE,
  DELIMITER_SETTING_CLEAR_STATE,
  DELIMITER_SETTING_UPDATE_ID,
  DELIMITER_SETTING_UPDATE_LOADING,
  DELIMITER_SETTING_UPDATE_INMUTABLE,
  DELIMITER_SETTING_UPDATE_FORM_VALID,
} from '../actions';
import { ResponseBadRequest } from '@core/interfaces';
import {
  ConfiguracionDelimitador,
  ConfiguracionDelimitadorForm,
} from '@core/models';
import { transformDelimiterSettingData } from '@core/helpers';

export interface DelimiterSettingState {
  loading: boolean;
  editMode: boolean;
  isEditing: boolean;
  delimiterSettingId: string | null;
  delimiterSetting: ConfiguracionDelimitador | null;
  delimiterSettingList: ConfiguracionDelimitador[];
  delimiterSettingForm: ConfiguracionDelimitadorForm | null;
  delimiterSettingInmutable: boolean,
  formValid: boolean,
  error: ResponseBadRequest | null;
}

export const initialState: DelimiterSettingState = {
  loading: false,
  isEditing: false,
  editMode: false,
  delimiterSettingId: null,
  delimiterSetting: null,
  delimiterSettingList: [],
  delimiterSettingForm: null,
  delimiterSettingInmutable: false,
  formValid: false, 
  error: null,
};

export const delimiterSettingReducer = createReducer(
  initialState,
  on(DELIMITER_SETTING_EDIT_MODE, (state, { editMode, isEditing }) => ({ ...state, editMode, isEditing })),
  on(DELIMITER_SETTING_FIND_SUCCESS, (state, { delimiterSetting }) => ({ ...state, delimiterSetting: transformDelimiterSettingData(delimiterSetting) })),
  on(DELIMITER_SETTING_FIND_ALL_SUCCESS, (state, { delimiterSettingList }) => ({ ...state, delimiterSettingList })),
  on(DELIMITER_SETTING_FAILURE, (state, { error }) => ({ ...state, error })),
  on(DELIMITER_SETTING_UPDATE_LOADING, (state, { loading }) => ({ ...state, loading })),
  on(DELIMITER_SETTING_UPDATE_FORM, (state, { delimiterSettingForm }) => ({ ...state, delimiterSettingForm })),
  on(DELIMITER_SETTING_UPDATE_FORM_VALID, (state, { formValid }) => ({ ...state, formValid })),
  on(DELIMITER_SETTING_UPDATE_INMUTABLE, (state, { inmutable }) => ({ ...state, delimiterSettingInmutable: inmutable })),
  on(DELIMITER_SETTING_UPDATE_ID, (state, { delimiterSettingId }) => ({ ...state, delimiterSettingId })),
  on(DELIMITER_SETTING_RESET, (state) => ({ ...state, delimiterSetting: null, delimiterSettingId: null, delimiterSettingForm: null })),
  on(DELIMITER_SETTING_RESET_ERROR, (state) => ({ ...state, error: null })),
  on(DELIMITER_SETTING_RESET_FORM, (state) => ({ ...state, delimiterSettingForm: null, loading: false })),
  on(DELIMITER_SETTING_CLEAR_STATE, (state) => ({ ...state, ...initialState, loading: state.loading })),
);